import React from 'react';
import styles from './appLoader.scss';

export const AppLoader = React.createClass({
    render () {
        return (
            <div className={styles.loader}>
                <i className="fa fa-spinner fa-pulse fa-3x fa-fw margin-bottom" />
                <span className="sr-only">Loading...</span>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/appLoader/AppLoader.js
 **/